var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getAuthorityShowAI
    ? _c(
        "div",
        {
          class: {
            "ai-helper-container": true,
            "ai-mask": _vm.visibleSlideBar || _vm.visibleFullScreen,
          },
        },
        [
          _vm.showAI && _vm.showAIIcon && !_vm.ifClose
            ? _c("AiIcon", {
                nativeOn: {
                  mousedown: function ($event) {
                    return _vm.mousedownIcon.apply(null, arguments)
                  },
                  mouseup: function ($event) {
                    return _vm.mouseupIcon.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm.visibleSlideBar ? _c("SlideBar") : _vm._e(),
          _vm.visibleFullScreen
            ? _c("FullScreen", { ref: "fullScreen" })
            : _vm._e(),
          _vm.isShowInletAI && _vm.getAuthorityShowAI
            ? _c("inletAI", {
                on: {
                  ok: function ($event) {
                    _vm.isShowInletAI = false
                  },
                },
              })
            : _vm._e(),
          _vm.getAuthorityShowAI ? _c("CopyContentDetectionDialog") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }